/**
 * Checks if the current environment is a server
 */
export function isServer() {
  return global.window === undefined;
}
